/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button as AntButton,
  Form,
  Modal,
  notification,
  Select,
  Tooltip,
  Typography,
  Upload,
  Row,
  Col,
  Table,
  Checkbox,
  Input,
  Spin,
  Radio,
} from 'antd';
import {
  PlusOutlined,
  EyeOutlined,
  MoreOutlined,
  UploadOutlined,
  CloudUploadOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  DeleteOutlined,
  RightCircleOutlined,
  SettingOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Truck, ChevronLeft, Plus } from 'lucide-react';
import { Button as CrcButton } from '@crc-evans/ui-components';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import { get } from 'lodash';
import axios from 'axios';
import AddNewShipmentType from './AddNewShipmentType';
import ShipmentNo from './ShipmentNo';
import AddNewShipmentNumber from './AddNewShipmentNumber';
import { fetchShipmentTypeDetails, fetchShipments } from '../../redux/ShipmentDetails/actions';
import { fetchShipmentDashBoardDetails } from '../../redux/ShipmentDashboardDetails/actions';
import {
  getExportDataListFromDatabase,
  OnDeleteShipmentType,
  OnPreviewShipmentNumber,
  OnAddShipmentNumber,
  OnAddorUpdateShipmentType,
  OnBulkUpdateShipmentStatus,
  OnDeleteShipmentNumber,
} from '../../redux/ShipmentDetails/saga';
import CommonAGGridTable from '../AG Grid/CommonAGGridTable';
import ShipmentLogs from './ShipmentLogs';
import './ShippingManagement.css';

const { Text, Title } = Typography;

// Add custom styles for checkbox
const customCheckboxStyle = `
.custom-checkbox .ant-checkbox-inner {
    width: 18px;
    height: 18px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    background-color: transparent;
}
.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #ef314c;
    border-color: #ef314c;
}
.custom-checkbox:hover .ant-checkbox-inner {
    border-color: #ef314c;
}
.custom-checkbox .ant-checkbox-inner::after {
    width: 6px;
    height: 10px;
    top: 45%;
    left: 22%;
}
`;

const ShippingManagement = (props) => {
  const {
    shipmentsTypes,
    shipmentListData,
    shipmentTypesLoading,
    isShipmentsListLoading,
    onFetchShipments,
    shipmentData,
    shipmentDataLoading,
    onGetShipmentTypes,
  } = props;

  const [checkOpen, setChecksOpen] = useState(false);
  const [openPage, setOpenPage] = useState('');
  const [showAddModel, setShowAddModel] = useState(false);

  const [openShipmentNoPage, setOpenShipmentNoPage] = useState(false);
  const [showAddShipmentNumberModal, setShowAddShipmentNumberModal] = useState(false);

  //Shipment Types
  const [equipTypeForm] = Form.useForm();
  const [equipTypeSearchForm] = Form.useForm();

  const [openModal, setOpenModel] = useState(false);
  const [equipTypeList, setEquipTypeListDrop] = useState([
    {
      id: 1,
      Shipment_Types: 'Air Freight',
    },
    {
      id: 2,
      Shipment_Types: 'Sea Freight',
    },
    {
      id: 3,
      Shipment_Types: 'Land Courier',
    },
    {
      id: 4,
      Shipment_Types: 'Hand Carry',
    },
  ]);
  const [clear, setClear] = useState(false);
  const [paginationClear, setPaginationClear] = useState(false);
  const [equipmentType, setEquipmentType] = useState('');
  const [editModelValue, setEditModelValue] = useState('');
  const [editRecord, setEditRecord] = useState('');
  const [isEdit, setIsEdit] = useState('');

  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(100000);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isShipmentType, setIsShipmentType] = useState(false);

  const [searchCriteria, setSearchCriteria] = useState('');
  const [shipmentDataList, setShipmentDataList] = useState([]);
  const [searchType, setSearchType] = useState(null);
  const [searchFilterType, setSearchFilterType] = useState('');
  const [rowData, setRowData] = useState([]);
  const [archivedData, setArchivedData] = useState([]);
  const [nonArchivedData, setNonArchivedData] = useState([]);

  const [columnDefs, setColumnDefs] = useState([]);
  const [layoutSave, setLayoutSave] = useState(false);
  const [layoutLoad, setLayoutLoad] = useState(false);
  const [isPivotMode, setIsPivotMode] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isArchiveLoading, setIsArchiveLoading] = useState(false);
  const [error, setError] = useState(null);

  // Add state for selected rows
  const [selectedRows, setSelectedRows] = useState([]);

  // Add state for shipment types in dropdown
  const [shipmentTypesForDropdown, setShipmentTypesForDropdown] = useState([]);
  const [isLoadingShipmentTypes, setIsLoadingShipmentTypes] = useState(false);

  // Modernized shipment types state
  const [showShipmentTypesModal, setShowShipmentTypesModal] = useState(false);
  const [shipmentTypesData, setShipmentTypesData] = useState([]);
  const [isShipmentTypesLoading, setIsShipmentTypesLoading] = useState(false);

  const [previewShipmentNumber, setPreviewShipmentNumber] = useState('');
  const [selectedShipmentType, setSelectedShipmentType] = useState(null);
  const [addShipmentPriority, setAddShipmentPriority] = useState('medium');
  const [addShipmentCategory, setAddShipmentCategory] = useState('project');
  const [addShipmentPackaging, setAddShipmentPackaging] = useState(undefined);
  const [addLoading, setAddLoading] = useState(false);

  // Add state for shipment type modal
  const [showShipmentTypeFormModal, setShowShipmentTypeFormModal] = useState(false);
  const [shipmentTypeForm] = Form.useForm();
  const [isEditShipmentType, setIsEditShipmentType] = useState(false);
  const [editingShipmentType, setEditingShipmentType] = useState(null);

  // Update initial state to false (show only active)
  const [showArchived, setShowArchived] = useState(false);

  // Add state for shipment type name
  const [shipmentTypeName, setShipmentTypeName] = useState('');

  // Add state for equipment type id
  const [equipmentTypeId, setEquipmentTypeId] = useState(null);

  // Add state for shipment logs
  const [isTableModelVisible, setIsTableModelVisible] = useState(false);
  const [showFormModel, setShowFormModel] = useState(false);

  // Add state for delete modal
  const [selectedDataSno, setSelectedDataSno] = useState(null);

  const [form] = Form.useForm();

  const [isPageLoading, setIsPageLoading] = useState(false);

  const handleEyeClick = async (record) => {
    setSelectedData(record);
    setIsTableModelVisible(true);
    setShowFormModel(true);
  };

  const handleOpenShipmentTypesModal = async () => {
    setShowShipmentTypesModal(true);
    setIsShipmentTypesLoading(true);
    try {
      const response = await getExportDataListFromDatabase();
      if (response && response.rows) {
        // Add S.No to each row
        const dataWithSno = response.rows.map((item, index) => ({
          ...item,
          sno: index + 1,
        }));
        setShipmentTypesData(dataWithSno);
      } else if (Array.isArray(response)) {
        // Add S.No to each row
        const dataWithSno = response.map((item, index) => ({
          ...item,
          sno: index + 1,
        }));
        setShipmentTypesData(dataWithSno);
      } else {
        setShipmentTypesData([]);
      }
    } catch (error) {
      console.error('Error fetching shipment types:', error);
      setShipmentTypesData([]);
    } finally {
      setIsShipmentTypesLoading(false);
    }
  };

  const handleEditShipmentType = (record) => {
    setIsEditShipmentType(true);
    setEditingShipmentType(record);
    shipmentTypeForm.setFieldsValue({
      name: record.name,
    });
    setShowShipmentTypeFormModal(true);
  };

  const handleNewShipmentType = () => {
    setIsEditShipmentType(false);
    setEditingShipmentType(null);
    shipmentTypeForm.resetFields();
    setShowShipmentTypeFormModal(true);
  };

  const handleCancelShipmentTypeForm = () => {
    setShowShipmentTypeFormModal(false);
    setIsEditShipmentType(false);
    setEditingShipmentType(null);
    shipmentTypeForm.resetFields();
  };

  // Search states for local filtering
  const [numSearch, setNumSearch] = useState('');
  const [statusSearch, setStatusSearch] = useState('');
  const [typeSearch, setTypeSearch] = useState('');
  const [invoiceSearch, setInvoiceSearch] = useState('');

  // Add search state for shipment types modal
  const [modalTypeSearch, setModalTypeSearch] = useState('');
  const shipmentTypesSearchInputRef = useRef(null);
  const [filteredShipmentTypesData, setFilteredShipmentTypesData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  /** Match List of Communications (ToolboxAdmin): default 20/page, controlled pagination */
  const [shipmentsListPage, setShipmentsListPage] = useState(1);
  const [shipmentsListPageSize, setShipmentsListPageSize] = useState(20);

  // Debounced search handlers
  const debouncedSetNumSearch = debounce((value) => setNumSearch(value), 300);
  const debouncedSetStatusSearch = debounce((value) => setStatusSearch(value), 300);
  const debouncedSetTypeSearch = debounce((value) => setTypeSearch(value), 300);
  const debouncedSetInvoiceSearch = debounce((value) => setInvoiceSearch(value), 300);
  const debouncedSetModalTypeSearch = debounce((value) => setModalTypeSearch(value), 300);

  // Helper for rendering searchable column titles matching Heat Profile style
  const renderColumnTitle = (title, onSearch, width = '100%') => (
    <div className="column-header-with-filter">
      <div className="column-header-text-wrapper">
        <span>{title}</span>
      </div>
      <div className="header-filter-input">
        <Input
          placeholder="Search"
          prefix={<SearchOutlined style={{ color: '#94a3b8', fontSize: '12px' }} />}
          onChange={(e) => onSearch(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          style={{ width: width === '100%' ? '140px' : width }}
          size="small"
          allowClear
        />
      </div>
    </div>
  );

  // Local filtering logic
  useEffect(() => {
    let data = rowData || [];
    if (numSearch) {
      data = data.filter(item =>
        item.shipmentNumber?.toLowerCase().includes(numSearch.toLowerCase())
      );
    }
    if (statusSearch) {
      data = data.filter(item =>
        item.status?.toLowerCase().includes(statusSearch.toLowerCase())
      );
    }
    if (typeSearch) {
      data = data.filter(item =>
        (item.shipmentType?.name || '').toLowerCase().includes(typeSearch.toLowerCase())
      );
    }
    if (invoiceSearch) {
      data = data.filter(item => {
        const submissions = item.submissions || [];
        const submission = submissions.find(sub => sub.invoice_number);
        const invNum = submission?.invoice_number || item.invoiceNumber || '';
        return invNum.toLowerCase().includes(invoiceSearch.toLowerCase());
      });
    }
    setFilteredData(data);
  }, [rowData, numSearch, statusSearch, typeSearch, invoiceSearch]);

  useEffect(() => {
    setShipmentsListPage(1);
  }, [numSearch, statusSearch, typeSearch, invoiceSearch, showArchived]);

  // Effect to filter shipment types data for the modal
  useEffect(() => {
    let data = [...shipmentTypesData];
    if (modalTypeSearch) {
      data = data.filter((item) =>
        item.name?.toLowerCase().includes(modalTypeSearch.toLowerCase())
      );
    }
    setFilteredShipmentTypesData(data);
  }, [shipmentTypesData, modalTypeSearch]);

  const typesListColumns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      key: 'sno',
      align: 'center',
      width: '80px',
      render: (text) => <span style={{ color: '#64748B', fontWeight: 500 }}>{text}</span>,
    },
    {
      title: renderColumnTitle('Shipment Types', debouncedSetModalTypeSearch),
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      render: (text) => <span style={{ color: '#1f2937', fontWeight: 500 }}>{text}</span>,
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      width: '180px',
      render: (text, record) => (
        <div className="heat-profile-actions-cell" style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Tooltip title="Edit Type">
            <EditOutlined
              className="txtIcon"
              style={{ color: '#64748B', fontSize: '18px', cursor: 'pointer' }}
              onClick={() => handleEditShipmentType(record)}
            />
          </Tooltip>
          <Tooltip title="View Shipments">
            <EyeOutlined
              className="txtIcon"
              style={{ color: '#64748B', fontSize: '18px', cursor: 'pointer' }}
              onClick={() => handleEyeClick(record)}
            />
          </Tooltip>
          <Tooltip title="Delete Type">
            <DeleteOutlined
              className="txtIcon"
              style={{ color: '#64748B', fontSize: '18px', cursor: 'pointer' }}
              onClick={() => showDeleteModal(record, true)}
            />
          </Tooltip>
          <Tooltip title="Manage Numbers">
            <RightCircleOutlined
              className="txtIcon"
              style={{ color: '#64748B', fontSize: '20px', cursor: 'pointer' }}
              onClick={async () => {
                setSelectedData(record);
                setChecksOpen(true);
                setOpenShipmentNoPage(true);
                setShipmentTypeName(record.name);
                setEquipmentTypeId(record.id);
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const modalTypesListColumns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      key: 'sno',
      align: 'center',
      width: 72,
      render: (text) => <span className="shipping-types-modal-sno">{text}</span>,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      render: (text) => <span className="shipping-types-modal-name">{text}</span>,
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      width: 160,
      render: (text, record) => (
        <div className="shipping-types-modal-actions">
          <Tooltip title="Edit Type">
            <EditOutlined className="shipping-types-modal-action-icon" onClick={() => handleEditShipmentType(record)} />
          </Tooltip>
          <Tooltip title="View Shipments">
            <EyeOutlined className="shipping-types-modal-action-icon" onClick={() => handleEyeClick(record)} />
          </Tooltip>
          <Tooltip title="Delete Type">
            <DeleteOutlined className="shipping-types-modal-action-icon" onClick={() => showDeleteModal(record, true)} />
          </Tooltip>
          <Tooltip title="Manage Numbers">
            <RightCircleOutlined
              className="shipping-types-modal-action-icon"
              onClick={async () => {
                setSelectedData(record);
                setChecksOpen(true);
                setOpenShipmentNoPage(true);
                setShipmentTypeName(record.name);
                setEquipmentTypeId(record.id);
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const shipmentColumns = [
    {
      title: renderColumnTitle('Shipment Number', debouncedSetNumSearch, '180px'),
      dataIndex: 'shipmentNumber',
      key: 'shipmentNumber',
      width: '220px',
      render: (text, record) => (
        <span style={record.status === 'ARCHIVED' ? { color: '#999', fontStyle: 'italic' } : {}}>
          {text}
        </span>
      ),
    },
    {
      title: renderColumnTitle('Status', debouncedSetStatusSearch, '120px'),
      dataIndex: 'status',
      key: 'status',
      width: '150px',
      render: (text) => (
        <span style={text === 'ARCHIVED' ? { color: '#999', fontStyle: 'italic' } : {}}>
          {text}
        </span>
      ),
    },
    {
      title: renderColumnTitle('Shipment Type', debouncedSetTypeSearch, '180px'),
      dataIndex: 'shipmentType',
      key: 'shipmentType',
      width: '220px',
      render: (type) => type?.name || '',
    },
    {
      title: renderColumnTitle('Invoice Number', debouncedSetInvoiceSearch, '180px'),
      dataIndex: 'invoiceNumber',
      key: 'invoiceNumber',
      width: '220px',
      render: (text, record) => {
        const submissions = record.submissions || [];
        const submission = submissions.find((sub) => sub.invoice_number);
        return submission?.invoice_number || record.invoiceNumber || '-';
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      width: '150px',
      align: 'center',
      fixed: 'right',
      render: (text, record) => (
        <div className="heat-profile-actions-cell" style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Tooltip title="View Shipment">
            <EyeOutlined
              className="txtIcon"
              style={{ color: '#00A86B', fontSize: '18px', cursor: 'pointer' }}
              onClick={() => handleEyeClick(record)}
            />
          </Tooltip>
          <Tooltip title="Delete Shipment">
            <DeleteOutlined
              className="txtIcon"
              style={{ color: '#ef314c', fontSize: '18px', cursor: 'pointer' }}
              onClick={() => {
                setSelectedData(record);
                setIsDeleteModalVisible(true);
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  // Update handleSelectionChanged function with more detailed logging

  // Update handleSelectionChanged function with more detailed logging
  const handleSelectionChanged = (params) => {
    // Handle both array and object params
    const selectedRows = Array.isArray(params) ? params : params?.api?.getSelectedRows() || [];

    // Log each selected row's details
    selectedRows.forEach((row, index) => { });

    setSelectedRows(selectedRows);
  };

  // Add useEffect to monitor selectedRows changes

  // Update the button style logic
  const getAntButtonStyle = (selectedRows) => {
    const isEnabled = selectedRows?.length > 0;
    return {
      opacity: isEnabled ? 1 : 0.5,
      cursor: isEnabled ? 'pointer' : 'not-allowed',
      pointerEvents: isEnabled ? 'auto' : 'none',
    };
  };

  // Update onGridReady handler with logging
  const onGridReady = (params) => {
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
  };

  // Update the column definitions to include checkbox selection
  const generateColumns = async () => {
    const columnDefs = [
      {
        headerName: 'S.No',
        field: 'sno',
        maxWidth: 150,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'center' },
        valueGetter: (params) => params.data.sno,
        suppressMovable: true,
        lockPosition: true,
        checkboxSelection: true,
        // headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Shipment Number',
        field: 'shipmentNumber',
        sortable: true,
        cellStyle: (params) => {
          if (params.data.status === 'ARCHIVED') {
            return {
              textAlign: 'left',
              color: '#999',
              fontStyle: 'italic',
            };
          }
          return { textAlign: 'left' };
        },
        suppressMovable: true,
        headerClass: 'ag-center-header',
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Status',
        field: 'status',
        sortable: true,
        cellStyle: (params) => {
          if (params.value === 'ARCHIVED') {
            return {
              textAlign: 'left',
              color: '#999',
              fontStyle: 'italic',
            };
          }
          return { textAlign: 'left' };
        },
        suppressMovable: true,
        headerClass: 'ag-center-header',
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Shipment Type',
        field: 'shipmentType',
        sortable: true,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        headerClass: 'ag-center-header',
        valueGetter: (params) => params.data?.shipmentType?.name || '',
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Priority',
        field: 'priority',
        sortable: true,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        headerClass: 'ag-center-header',
        valueGetter: (params) => {
          const p = String(params.data?.priority || '').toLowerCase();
          return (
            { high: 'High', medium: 'Medium', low: 'Low' }[p] || params.data?.priority || ''
          );
        },
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Category',
        field: 'shipmentCategory',
        sortable: true,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        headerClass: 'ag-center-header',
        valueGetter: (params) => {
          const key = String(params.data?.shipmentCategory || '')
            .toLowerCase()
            .replace(/-/g, '_');
          return (
            { project: 'Project', one_time_sales: 'One time sales' }[key] ||
            params.data?.shipmentCategory ||
            ''
          );
        },
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Subcategory',
        field: 'packagingType',
        sortable: true,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        headerClass: 'ag-center-header',
        valueGetter: (params) => {
          const raw = params.data?.packagingType ?? params.data?.packagingSubcategory;
          const form = packagingApiToFormValue(raw);
          const labels = { PALLET: 'Pallet', CRATE_BOX: 'Crate box', UNPACKED: 'Unpacked' };
          return form ? labels[form] : raw || '';
        },
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Invoice Number',
        field: 'invoiceNumber',
        sortable: true,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        headerClass: 'ag-center-header',
        valueGetter: (params) => {
          // Get invoice number from submissions if available
          const submissions = params.data?.submissions || [];
          const submission = submissions.find((sub) => sub.invoice_number);
          return submission?.invoice_number || params.data?.invoiceNumber || '';
        },
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Actions',
        field: 'editDelete',
        width: 150,
        pinned: 'right',
        headerClass: 'ag-center-header',
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <div className="tableIcons">
              <Tooltip
                title="View Shipment"
                placement="left"
              >
                <EyeOutlined
                  className="icon-18"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => handleEyeClick(record)}
                />
              </Tooltip>
              <Tooltip
                title="Edit shipment number"
                placement="top"
              >
                <EditOutlined
                  className="icon-18"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => openEditShipmentNumberModal(record)}
                />
              </Tooltip>
              <Tooltip
                title="Delete"
                placement="top"
              >
                <DeleteOutlined
                  className="icon-18"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => {
                    setSelectedData(record);
                    setIsDeleteModalVisible(true);
                  }}
                />
              </Tooltip>
            </div>
          );
        },
        cellStyle: { textAlign: 'center' },
        filter: false,
        suppressMovable: true,
      },
    ];

    setColumnDefs(columnDefs);
    return columnDefs;
  };
  useEffect(() => {
    generateColumns();
  }, []);

  useEffect(() => {
    (async () => {
      const list = await getExportDataListFromDatabase();

      if (list && list.rows.length > 0) setShipmentDataList(list.rows);
    })();
  }, []);

  useEffect(() => {
    if (shipmentListData && shipmentListData.length > 0) {
      setRowData(shipmentListData);
    }
  }, [shipmentListData]);

  /** Single list fetch: initial load + search changes (showArchived toggled via handleShowArchivedChange) */
  useEffect(() => {
    OnfetchData();
  }, [searchCriteria]);

  // Update OnfetchData to handle initial load
  const OnfetchData = async (params = {}) => {
    try {
      setIsLoading(true);
      setIsPageLoading(true);
      const queryParams = {
        ...params,
        status: params.status || (showArchived ? 'archived' : 'active'),
        pageSize: currentPagesize,
        pageNumber: searchCriteria !== '' ? 1 : currentPageNumber,
        searchKey: searchCriteria,
        projectId: props.selectedProject?.id,
      };
      await onFetchShipments(queryParams);
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch shipments',
      });
    } finally {
      setIsLoading(false);
      setIsPageLoading(false);
    }
  };

  const openEditShipmentNumberModal = (record) => {
    const typeId = record.shipmentTypeId ?? record.shipmentType?.id;
    if (!typeId) {
      notification.warning({
        message: 'Cannot edit',
        description: 'This row has no shipment type.',
      });
      return;
    }
    setShipmentNumberModalTypeId({ id: typeId });
    setEditShipmentNumberRecord(record);
    setIsEditShipmentNumberModal(true);
    setShowShipmentNumberCrudModal(true);
  };

  const showDeleteModal = (record, isType = false) => {
    setSelectedData(record);
    setIsShipmentType(isType);
    setIsDeleteModalVisible(true);
  };

  const handleOk = async () => {
    setDeleteLoading(true);
    try {
      if (isShipmentType) {
        await OnDeleteShipmentType(selectedData);
        await handleOpenShipmentTypesModal();
      } else {
        await OnDeleteShipmentNumber(selectedData);
        await OnfetchData({
          status: showArchived ? 'archived' : 'active',
          projectId: props.selectedProject?.id,
        });
      }

      notification.success({
        message: 'Success',
        description: `Successfully deleted ${isShipmentType ? 'shipment type' : 'shipment'}`,
      });

      setIsDeleteModalVisible(false);
      setSelectedData(null);
      setIsShipmentType(false);
    } catch (error) {
      notification.error({
        message: 'Error',
        description: `Failed to delete ${isShipmentType ? 'shipment type' : 'shipment'}`,
      });
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleCancel = () => {
    setIsDeleteModalVisible(false);
    setSelectedData(null);
    setIsShipmentType(false);
  };

  const handleSearchInputChange = (value) => {
    //  if (value != '')
    setSearchFilterType(value);
    if (searchFilterType.length == 1 || value != '') setSearchCriteria(value);
    // else
    //     setSearchCriteria('');
  };

  const handleComboboxChange = async (value) => {
    setSearchType(value);
    if (value) setSearchCriteria(value);
    else setSearchCriteria('');
  };
  const handleSearchBlur = () => {
    const isValid = EquipmentDataList.some(
      (item) => item.pihEquipmentType?.toLowerCase() === searchCriteria?.toLowerCase()
    );
    if (!isValid) {
      console.log('handleSearchBlur', isValid);
      setSearchCriteria('');
      setSearchType(undefined);
    }
  };
  const tagRender = (props) => {
    return null;
  };

  /** clearing selected data from equipment type dropdown */
  const OnclearEquipType = () => {
    setClear(false);
    setSearchCriteria('');
    setSearchFilterType('');
    setSearchType(null);
    equipTypeSearchForm.resetFields();
    // setEquipTypeList(adminEquipTypes)
    setPaginationClear(false);
    // onGetPihEquipmentTypes({
    //     pageSize: 10,
    //     pageNumber: 1
    // });
    // setEquipTypeListDrop(adminEquipTypes);
  };

  useEffect(() => {
    if (shipmentData && shipmentData.length > 0) {
      const archived = shipmentData.filter((item) => item.status === 'ARCHIVED');
      const nonArchived = shipmentData.filter((item) => item.status !== 'ARCHIVED');

      setArchivedData(archived);
      setNonArchivedData(nonArchived);

      setRowData(showArchived ? archived : nonArchived);

      if (gridApi) {
        gridApi.setRowData(showArchived ? archived : nonArchived);
        gridApi.refreshCells({ force: true });
        gridApi.redrawRows();
      }
    }
  }, [shipmentData]);

  useEffect(() => {
    if (shipmentData && shipmentData.length > 0) {
      const filteredData = showArchived
        ? shipmentData.filter((item) => item.status === 'ARCHIVED')
        : shipmentData.filter((item) => item.status !== 'ARCHIVED');

      setRowData([...filteredData]);

      if (gridApi) {
        gridApi.setRowData([...filteredData]);
        gridApi.refreshCells({ force: true });
        gridApi.redrawRows();
      }
    }
  }, [shipmentData, showArchived]);

  // Update handleShowArchivedChange to use loading state
  const handleShowArchivedChange = async (e) => {
    const isChecked = e.target.checked;
    setShowArchived(isChecked);
    setIsArchiveLoading(true);
    setIsLoading(true);
    setIsPageLoading(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 100));
      await OnfetchData({
        status: isChecked ? 'archived' : 'active',
      });
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch shipments',
      });
    } finally {
      setTimeout(() => {
        setIsArchiveLoading(false);
        setIsLoading(false);
        setIsPageLoading(false);
      }, 500);
    }
  };

  // Update handleArchiveSelected to use loading state
  const handleArchiveSelected = async () => {
    if (!selectedRows || selectedRows.length === 0) {
      notification.warning({
        message: 'Warning',
        description: 'Please select shipments to archive',
      });
      return;
    }

    try {
      setIsLoading(true);
      setDeleteLoading(true);
      setIsPageLoading(true);

      const payload = {
        shipmentIds: selectedRows.map((row) => row.id),
        status: 'archived',
      };

      const result = await OnBulkUpdateShipmentStatus(payload);
      if (result) {
        notification.success({
          message: 'Success',
          description: `Successfully archived ${selectedRows.length} shipment(s)`,
        });

        setSelectedRows([]);
        if (gridApi) {
          gridApi.deselectAll();
        }

        await OnfetchData({
          status: 'active',
          projectId: props.selectedProject?.id,
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to archive shipments',
      });
    } finally {
      setIsLoading(false);
      setDeleteLoading(false);
      setIsPageLoading(false);
    }
  };

  useEffect(() => {
    if (showAddShipmentNumberModal) {
      setAddShipmentPriority('medium');
      setAddShipmentCategory('project');
      setAddShipmentPackaging(undefined);
    }
  }, [showAddShipmentNumberModal]);

  const handleAddAntButtonClick = async () => {
    setShowAddShipmentNumberModal(true);
    // Fetch shipment types when modal opens
    await fetchShipmentTypesForDropdown();
  };

  // Add function to fetch shipment types for dropdown
  const fetchShipmentTypesForDropdown = async () => {
    setIsLoadingShipmentTypes(true);
    try {
      const response = await getExportDataListFromDatabase();
      if (response && response.rows) {
        setShipmentTypesForDropdown(response.rows);
        // Set the first shipment type as default and get preview
        if (response.rows.length > 0) {
          setSelectedShipmentType(response.rows[0].id);
        }
      } else if (Array.isArray(response)) {
        setShipmentTypesForDropdown(response);
        if (response.length > 0) {
          setSelectedShipmentType(response[0].id);
        }
      } else {
        setShipmentTypesForDropdown([]);
      }
    } catch (error) {
      console.error('Error fetching shipment types:', error);
      setShipmentTypesForDropdown([]);
    } finally {
      setIsLoadingShipmentTypes(false);
    }
  };

  const handleConfirmAdd = async () => {
    try {
      // Validate form first
      await form.validateFields();

      if (!selectedShipmentType || !String(previewShipmentNumber || '').trim()) {
        notification.error({
          message: 'Error',
          description: 'Please select a shipment type and enter a shipment number',
        });
        return;
      }
      if (!addShipmentPackaging) {
        notification.error({
          message: 'Error',
          description: 'Please select packaging (subcategory)',
        });
        return;
      }

      setAddLoading(true);
      const payload = {
        shipment: {
          shipmentTypeId: selectedShipmentType,
          shipmentNumber: String(previewShipmentNumber).trim(),
          priority: addShipmentPriority,
          shipmentCategory: addShipmentCategory,
          packagingType: packagingFormValueToApi(addShipmentPackaging),
        },
      };

      const response = await OnAddShipmentNumber(payload);
      if (response?.shipment?.shipmentNumber) {
        await OnfetchData();

        setShowAddShipmentNumberModal(false);
        setSelectedShipmentType(null);
        setPreviewShipmentNumber('');
        setAddShipmentPackaging(undefined);
        form.resetFields();
      }
    } catch (error) {
      notification.error({
        message: 'Failed to add shipment number',
      });
    } finally {
      setAddLoading(false);
    }
  };

  const handleCancelAdd = () => {
    setShowAddShipmentNumberModal(false);
    setPreviewShipmentNumber('');
    setSelectedShipmentType(null);
    setAddShipmentPackaging(undefined);
    form.resetFields();
  };

  // Add function to handle shipment type form submission
  const handleShipmentTypeSubmit = async (values) => {
    try {
      setAddLoading(true);
      const payload = {
        id: isEditShipmentType ? editingShipmentType.id : undefined,
        data: {
          name: values?.name || '',
        },
      };

      await OnAddorUpdateShipmentType(payload, isEditShipmentType);
      notification.success({
        message: `Shipment type ${isEditShipmentType ? 'updated' : 'created'} successfully`,
      });
      await handleOpenShipmentTypesModal(); // Refresh the list
      setShowShipmentTypeFormModal(false);
      shipmentTypeForm.resetFields();
      setIsEditShipmentType(false); // Reset edit mode
      setEditingShipmentType(null); // Clear editing data
    } catch (error) {
      notification.error({
        message: `Failed to ${isEditShipmentType ? 'update' : 'create'} shipment type`,
        description: error?.message || 'An error occurred',
      });
    } finally {
      setAddLoading(false);
    }
  };

  // Add function to handle bulk status update
  const handleBulkStatusUpdate = async (status) => {
    if (selectedRows.length === 0) {
      notification.warning({
        message: 'Please select shipments to update',
      });
      return;
    }

    try {
      const payload = {
        shipmentIds: selectedRows.map((row) => row.id),
        status: status,
      };

      const result = await OnBulkUpdateShipmentStatus(payload);
      if (result) {
        await OnfetchData(); // Refresh the data
        setSelectedRows([]); // Clear selection
      }
    } catch (error) {
      console.error('Error updating shipment statuses:', error);
    }
  };

  // Add delete handlers
  const handleDeleteOk = async () => {
    setDeleteLoading(true);
    try {
      await OnDeleteShipmentNumber(selectedDataSno);
      await OnfetchData({
        status: showArchived ? 'archived' : 'active',
        projectId: props.selectedProject?.id,
      });
      notification.success({
        message: 'Success',
        description: 'Shipment deleted successfully',
      });
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to delete shipment',
      });
    } finally {
      setDeleteLoading(false);
      setIsDeleteModalVisible(false);
      setSelectedDataSno(null);
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
    setSelectedDataSno(null);
  };

  const rowSelection = {
    selectedRowKeys: selectedRows.map(row => row.id),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRows);
    },
  };

  return (
    <div className="heat-profile-content-wrapper modern-shipping-mgmt">
      <style>{customCheckboxStyle}</style>
      {isPageLoading && (
        <div className="heat-profile-loader-overlay">
          <Spin size="large" tip="Loading Shipping Data..." />
        </div>
      )}

      {/* Main Shipments List View */}
      {!openShipmentNoPage && (
        <div className="heat-profile-card">
          <div className="heat-profile-list-header">
            <div className="heat-profile-header-left">
              <div className="heat-profile-icon-wrap">
                <Truck size={22} color="#64748B" />
              </div>
              <div className="heat-profile-header-content">
                <Title level={4} className="heat-profile-list-title">List of Shipments</Title>
                <p className="heat-profile-list-description">Manage shipments inventory, statuses, and assignments.</p>
              </div>
            </div>

            <div className="heat-profile-header-actions">
              <Checkbox
                checked={showArchived}
                onChange={handleShowArchivedChange}
                className="custom-checkbox"
                disabled={isArchiveLoading}
              >
                <span style={{ fontSize: '13px', fontWeight: 500 }}>
                  {isArchiveLoading ? 'Loading...' : 'Show Archived'}
                </span>
              </Checkbox>
              <AntButton
                type="default"
                icon={<SettingOutlined />}
                onClick={handleOpenShipmentTypesModal}
                className="heat-profile-filter-btn"
              >
                Shipment Types
              </AntButton>

              <AntButton
                type="default"
                danger
                disabled={selectedRows.length === 0 || isLoading}
                onClick={handleArchiveSelected}
                className="heat-profile-filter-btn"
              >
                {isLoading ? 'Archiving...' : `Archive Selected (${selectedRows.length})`}
              </AntButton>

              <AntButton
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => setShowAddShipmentNumberModal(true)}
                className="heat-profile-add-btn"
              >
                Add Shipment Number
              </AntButton>
            </div>
          </div>

          <div className="heat-profile-table-wrap">
            <Table
              className="heat-profile-table"
              columns={shipmentColumns}
              dataSource={filteredData}
              rowKey="id"
              rowSelection={rowSelection}
              loading={shipmentDataLoading || isShipmentsListLoading || isLoading || isArchiveLoading}
              pagination={{
                current: shipmentsListPage,
                pageSize: shipmentsListPageSize,
                total: filteredData.length,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (page, size) => {
                  setShipmentsListPage(page);
                  setShipmentsListPageSize(size);
                },
              }}
              scroll={{ x: 1200 }}
            />
          </div>
        </div>
      )}

      {openShipmentNoPage && (
        <div>
          <div className="back_equip">
            <Tooltip title={' Back'}>
              <ArrowLeftOutlined
                onClick={() => {
                  setChecksOpen(false);
                  setOpenPage('');
                  setOpenShipmentNoPage(false);
                  setShipmentTypeName('');
                  setSelectedData(null); // Clear selected data when closing
                }}
              />
            </Tooltip>
            <Text style={{ fontSize: '16px', paddingLeft: '10px' }}>{shipmentTypeName}</Text>
          </div>
          <ShipmentNo
            selectedData={selectedData}
            onDeleteSuccess={() => {
              // Refresh data after successful deletion
              OnfetchData({
                status: showArchived ? 'archived' : 'active',
                projectId: props.selectedProject?.id,
              });
            }}
          />
        </div>
      )}

      <AddNewShipmentType
        showAddModel={showAddModel}
        setShowAddModel={setShowAddModel}
        setIsEdit={setIsEdit}
        editRecord={editRecord}
        isEdit={isEdit}
        OnfetchData={OnfetchData}
      ></AddNewShipmentType>

      {/* Delete Modal for Shipment Number */}
      <Modal
        width={500}
        className="heatprofile-modal"
        title="Delete Shipment Number"
        centered
        visible={isDeleteModalVisible && !isShipmentType}
        onCancel={handleCancel}
        footer={[
          <AntButton key="cancel" onClick={handleCancel}>Cancel</AntButton>,
          <AntButton
            key="delete"
            type="primary"
            danger
            onClick={handleOk}
            loading={deleteLoading}
          >
            Delete
          </AntButton>,
        ]}
      >
        <div style={{ padding: '10px 0' }}>
          <Text style={{ fontSize: '15px', color: '#333' }}>
            <p>
              Deleting shipment number will remove all corresponding stations and related information.
            </p>
            Are you sure you want to delete <strong style={{ color: '#000000', fontWeight: 'bold' }}>{selectedData?.shipmentNumber}</strong>?
          </Text>
        </div>
      </Modal>

      {/* Delete Modal for Shipment Type */}
      <Modal
        width={500}
        className="heatprofile-modal"
        title="Delete Shipment Type"
        centered
        visible={isDeleteModalVisible && isShipmentType}
        onCancel={handleCancel}
        footer={[
          <AntButton key="cancel" onClick={handleCancel}>Cancel</AntButton>,
          <AntButton
            key="delete"
            type="primary"
            danger
            onClick={handleOk}
            loading={deleteLoading}
          >
            Delete
          </AntButton>,
        ]}
      >
        <div style={{ padding: '10px 0' }}>
          <Text style={{ fontSize: '15px', color: '#333' }}>
            <p>
              Deleting shipment type will remove all corresponding shipment numbers and related information.
            </p>
            Are you sure you want to delete <strong style={{ color: '#000000', fontWeight: 'bold' }}>{selectedData?.name}</strong>?
          </Text>
        </div>
      </Modal>

      {/* Shipment Type Details Modal */}
      <Modal
        width={500}
        className="heatprofile-modal"
        title={isEditShipmentType ? 'Update Shipment Type' : 'Create New Shipment Type'}
        centered
        visible={showShipmentTypeFormModal}
        onCancel={handleCancelShipmentTypeForm}
        footer={[
          <AntButton key="cancel" onClick={handleCancelShipmentTypeForm}>Cancel</AntButton>,
          <AntButton
            key="apply"
            type="primary"
            onClick={() => shipmentTypeForm.submit()}
            loading={addLoading}
          >
            {isEditShipmentType ? 'Update' : 'Create'}
          </AntButton>,
        ]}
      >
        <div style={{ padding: '20px 0' }}>
          <Form
            form={shipmentTypeForm}
            layout="vertical"
            onFinish={handleShipmentTypeSubmit}
          >
            <Form.Item
              label="Shipment Type Name"
              name="name"
              rules={[
                { required: true, message: 'Please enter shipment type name' },
                { max: 50, message: 'Name cannot exceed 50 characters' },
              ]}
            >
              <Input placeholder="Enter shipment type name" size="large" />
            </Form.Item>
          </Form>
        </div>
      </Modal>

      {/* Shipment Types List Modal - modern UI */}
      <Modal
        title="Shipment Types"
        visible={showShipmentTypesModal}
        onCancel={() => setShowShipmentTypesModal(false)}
        footer={[
          <CrcButton
            key="close"
            label="Close"
            variant="tertiary"
            onClick={() => setShowShipmentTypesModal(false)}
            size="medium"
          />,
        ]}
        width={800}
        centered
        className="heatprofile-modal shipping-types-modal"
      >
        <div className="shipping-types-modal-body">
          <div className="shipping-types-modal-toolbar">
            <div
              className="shipment-types-search-box"
              role="search"
              onClick={() => shipmentTypesSearchInputRef.current?.focus()}
            >
              <SearchOutlined className="shipment-types-search-box-icon" aria-hidden />
              <input
                ref={shipmentTypesSearchInputRef}
                type="text"
                className="shipment-types-search-box-input"
                placeholder="Search shipment types"
                value={modalTypeSearch}
                onChange={(e) => setModalTypeSearch(e.target.value)}
                aria-label="Search shipment types"
              />
              {modalTypeSearch ? (
                <button
                  type="button"
                  className="shipment-types-search-box-clear"
                  onClick={(e) => {
                    e.stopPropagation();
                    setModalTypeSearch('');
                  }}
                  aria-label="Clear search"
                >
                  ×
                </button>
              ) : null}
            </div>
            <CrcButton
              label="Add New Type"
              variant="primary"
              icon={Plus}
              onClick={handleNewShipmentType}
              size="medium"
            />
          </div>
          <Table
            className="shipping-types-modal-table"
            columns={modalTypesListColumns}
            dataSource={filteredShipmentTypesData}
            rowKey="id"
            loading={isShipmentTypesLoading}
            pagination={false}
            size="small"
            showHeader
            scroll={{ y: 400 }}
            footer={() => (
              <div className="shipping-types-modal-total">
                Total: {filteredShipmentTypesData.length}
              </div>
            )}
          />
        </div>
      </Modal>

      {/* Add Shipment Number Modal */}
      <Modal
        width={500}
        className="heatprofile-modal"
        title="Confirm New Shipment Number"
        centered
        visible={showAddShipmentNumberModal}
        onCancel={handleCancelAdd}
        footer={[
          <AntButton key="cancel" onClick={handleCancelAdd}>Cancel</AntButton>,
          <AntButton
            key="confirm"
            type="primary"
            onClick={handleConfirmAdd}
            loading={addLoading}
            disabled={
              !selectedShipmentType ||
              !String(previewShipmentNumber || '').trim() ||
              !addShipmentPackaging
            }
          >
            Confirm Create
          </AntButton>,
        ]}
      >
        <div>
          <Form
            form={form}
            layout="vertical"
            onValuesChange={(changedValues) => {
              if (changedValues.shipmentType) {
                setSelectedShipmentType(changedValues.shipmentType);
              } else {
                setSelectedShipmentType(null);
                setPreviewShipmentNumber('');
              }
            }}
          >
            <Form.Item
              label="Shipment Type"
              name="shipmentType"
              rules={[{ required: true, message: 'Please select a shipment type' }]}
              validateTrigger={['onChange', 'onBlur']}
            >
              <Select
                placeholder="Select Shipment Type"
                loading={isLoadingShipmentTypes}
                getPopupContainer={(trigger) => trigger.parentNode}
                dropdownClassName="heat-profile-select-dropdown"
                onDropdownVisibleChange={(open) => {
                  if (open) {
                    fetchShipmentTypesForDropdown();
                  }
                }}
                onChange={(value) => {
                  if (value) {
                    form.setFieldsValue({ shipmentType: value });
                    setSelectedShipmentType(value);
                  } else {
                    form.setFieldsValue({ shipmentType: undefined });
                    setSelectedShipmentType(null);
                    setPreviewShipmentNumber('');
                  }
                }}
                allowClear={false}
              >
                {shipmentTypesForDropdown.map((type) => (
                  <Select.Option
                    key={type.id}
                    value={type.id}
                  >
                    {type.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {selectedShipmentType && previewShipmentNumber && (
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <Text style={{ fontSize: '16px', display: 'block', marginBottom: '10px' }}>
                  Do you want to add the following shipment number?
                </Text>
                <Text
                  style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: '#000000',
                    display: 'block',
                  }}
                >
                  {previewShipmentNumber}
                </Text>
              </div>
            )}
          </Form>
        </div>
      </Modal>

      {showShipmentNumberCrudModal && shipmentNumberModalTypeId ? (
        <AddNewShipmentNumber
          showAddModel={showShipmentNumberCrudModal}
          setShowAddModel={(open) => {
            setShowShipmentNumberCrudModal(open);
            if (!open) {
              setEditShipmentNumberRecord(null);
              setIsEditShipmentNumberModal(false);
              setShipmentNumberModalTypeId(null);
            }
          }}
          selectedData={shipmentNumberModalTypeId}
          editRecord={editShipmentNumberRecord}
          setIsEdit={setIsEditShipmentNumberModal}
          isEdit={isEditShipmentNumberModal}
          OnfetchData={async () => {
            await OnfetchData({
              status: showArchived ? 'archived' : 'active',
              projectId: props.selectedProject?.id,
            });
          }}
        />
      ) : null}

      {/* Add ShipmentLogs component */}
      {showFormModel && (
        <ShipmentLogs
          showFormModel={showFormModel}
          setShowFormModel={setShowFormModel}
          selectedData={selectedData}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ ShipmentReducer, ShipmentDashBoardReducer }) => {
  const shipmentsTypes = get(ShipmentReducer, 'shipmentData', []);
  const shipmentListData = get(ShipmentReducer, 'shipmentListData', []);
  const shipmentTypesLoading = get(ShipmentReducer, 'isShipmentTypeLoading', false);
  const isShipmentsListLoading = get(ShipmentReducer, 'isShipmentsListLoading', false);
  const shipmentTypesCount = get(ShipmentReducer, 'isShipmentTypeLoading', false);
  const shipmentData = get(ShipmentDashBoardReducer, 'shipmentListData', []);
  const shipmentDataLoading = get(ShipmentDashBoardReducer, 'isShipmentsLoading', false);
  return {
    shipmentsTypes,
    shipmentListData,
    shipmentTypesLoading,
    isShipmentsListLoading,
    shipmentTypesCount,
    shipmentData,
    shipmentDataLoading,
  };
};

const mapDispatchToProps = {
  onGetShipmentTypes: fetchShipmentTypeDetails,
  onFetchShipments: fetchShipments,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippingManagement);
